import React, { useEffect, useState,useRef } from "react";
import Button from "components/button/button";
import { HiOutlinePencil } from "react-icons/hi";
import { FiCheck } from "react-icons/fi";
import toast from "react-hot-toast";
import LoadingIndicator from "assets/svg/loading-indicator";
import Input from "components/input/input";
import _ from "lodash";
import PopInfo from "components/info-popup/pop-info";
import update from "immutability-helper";
import { FaMinus } from "react-icons/fa";
import Members from "components/settings/component/Members";
import { useTranslation } from "react-i18next";
import Popup from "reactjs-popup";
import { FaEllipsisH  } from "react-icons/fa";
import { IoLanguageOutline } from "react-icons/io5";
import { currentLang } from "utils/utils";
 

const GroupMembers = (props) => {
  const { profile, userData, setUserData } = props;
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const { http, localstorage } = global.services;
  const {t} = useTranslation();
  const optionRef = useRef();
  const [loadingTranslate , setTransLoad] = useState(false);
  const [showMoreOption, setShowMoreOption] = useState();
  const lang = currentLang();
  const [translate,setTranslate] = useState(null);

  const buttonProps = {
    edit: {
      btnName: t("edit"),
      icon: <HiOutlinePencil />,
      btnClass: "relative px-6 py-2 bg-white hover:bg-gray hover:rounded-b-md justify-start w-full",
      btnTextClass:"text-lg  flex flex-row items-center gap-2",
    },
    save: {
    btnName: t("saveChanges"),
    icon: <FiCheck className="text-lg" />,
    btnClass: "relative py-3.6 px-5.5 bg-primary hover:bg-darkPrimary",
    btnTextClass:
      "text-sm text-white font-semibold flex items-center space-x-1.6",
  },
  };

  const onClickSave = async () => {
    setLoading(true);
    let payload = {
      profileGroup: JSON.stringify(members),
      profileTypes: profile?.profile_type?.type || "",
    };
    const { data } = await http.put(
      `public/profiles/update-members-information/${profile?.id}`,
      payload
    );

    if (data) {
      updateProfile(data);
      toast.success(t('memberMessage'));
    }
  };

  useEffect(() => {
    window.addEventListener(
        "scroll",
        () => {  
            if (optionRef.current) {
                optionRef.current.close();
            }
        },
        true
    );
    return () => {
        window.removeEventListener("scroll", () => {});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      let members = profile?.profile_type?.members;
      let translate = profile?.profile_type?.translation;
      if(translate){
        setTranslate(translate);
      }
      if (members) {
        setMembers(JSON.parse(members));
      } else {
        setMembers([]);
      }
    }
  }, [profile]);

  const onChange = (e, index) => {
    e.stopPropagation();
    let name = "";
    if (e.target.name === `name-${index}`) {
      name = e.target.value;
    } else {
      name = members[index].name;
    }

    let role = "";
    if (e.target.name === `role-${index}`) {
      role = e.target.value;
    } else {
      role = members[index].role;
    }

    let dateSE = "";
    if (e.target.name === `dateSE-${index}`) {
      dateSE = e.target.value;
    } else {
      dateSE = members[index].dateSE;
    }

    let payload = _.clone(members);
    let result = update(payload, {
      [index]: {
        name: { $set: name },
        role: { $set: role },
        dateSE: { $set: dateSE },
      },
    }); //remove
    setMembers(result);
  };

  const onRemoveMembers = (index) => {
    let payload = _.clone(members);
    let result = update(payload, { $splice: [[index, 1]] }); //remove
    setMembers(result);
  };

  const onAddMembers = () => {
    let payload = _.clone(members);
    payload.push({ name: "", role: "", dateSE: "" });
    setMembers(payload);
  };

  const translateGroupMemInfo = async()=>{
      if (userData?.profile?.id === profile?.id) {
          try{
              setTransLoad(true)
              let curLang = localStorage.getItem('lang');
              const { data } = await http.put(`public/profile/${profile?.id}/translate-members`,{
                  lang:curLang
              }); 
              if(data.data){
                  updateProfile(data)
                  toast.success(t('completedTranslate'))
              }else{
                  toast.success(t('beenTranslated'));
              }
              setTransLoad(false)
          }catch(e){
              setTransLoad(false)
              toast.error(t('somethingWentWrong'));
          }
      }
    }

  const updateProfile = (data)=>{ 
      let profileRes = data.data;
      const updatedData = { ...userData, profile: data.data };
      setUserData(updatedData);
      localstorage.set("user_data", JSON.stringify(updatedData)); 
      let members = profileRes?.profile_type?.members;
      let translate = profileRes?.profile_type?.translation;
      if(translate){
        setTranslate(translate);
      }
      if (members) {
        setMembers(JSON.parse(members));
      }  
      //update state to false
      setLoading(false);
      setEdit(false);
  }

  return (
    <div className="w-full bg-white rounded-md px-5 2md:pl-29 2md:pr-24.5 py-10 md:pb-14 md:pt-8">
      <div className="w-full flex justify-between flex-wrap items-center mb-4">
        <div className="flex flex-row gap-x-2 items-center">
          <h1 className="text-2xl font-semibold text-lightBlack">{t("members")}</h1>
          <PopInfo containerClass="relative" type={`${['group'].includes(profile?.profile_type?.type) ? 'members' : 'members_team'}`} />
        </div>
        {props.isYourProfile && (
          <>
          {
            edit ?
            <div className="flex gap-2">
            <Button
              buttonName={
                edit ? buttonProps.save.btnName : buttonProps.edit.btnName
              }
              buttonTextClass={
                edit
                  ? buttonProps.save.btnTextClass
                  : buttonProps.edit.btnTextClass
              }
              iconPosition="left"
              icon={edit ? buttonProps.save.icon : buttonProps.edit.icon}
              buttonRadius="6px"
              buttonClass={
                edit ? buttonProps.save.btnClass : buttonProps.edit.btnClass
              }
              loadingIcon={
                loading ? (
                  <LoadingIndicator className="text-white w-4 h-4" />
                ) : null
              }
              disabled={loading}
              onClick={() => {
                if (edit) {
                  onClickSave();
                } else {
                  setEdit((prev) => !prev);
                }
              }}
            />   
            {/* {
              edit && !loading && 
              <Button
                buttonName={t("cancel")}
                buttonTextClass={buttonProps.edit.btnTextClass}
                buttonClass={buttonProps.edit.btnClass}
                onClick={() => { 
                    setEdit((prev) => !prev); 
                }}
              /> 
            } */}
            </div>
            :
            <Popup
              ref={optionRef}
              position="bottom right"
              open={showMoreOption}
              onClose={() => setShowMoreOption(false)}
              arrow={false}
              contentStyle={{ marginTop: 10, marginLeft: 5 }}
              trigger={
                  <button
                      className="py-0 bg-thBg rounded-md 3md:py-4 3md:px-5 px-3"
                      onClick={() =>
                          setShowMoreOption((open) => !open)
                      }
                  >
                      <FaEllipsisH className="p-0 m-0" />
                  </button>
              }
            >
            <div className="flex flex-col shadow-lg rounded-md bg-white">
                <ul className="w-full">
                    <li className="hover:bg-gray hover:rounded-md">
                        <Button
                          buttonName={
                            edit ? buttonProps.save.btnName : buttonProps.edit.btnName
                          }
                          buttonTextClass={
                            edit
                              ? buttonProps.save.btnTextClass
                              : buttonProps.edit.btnTextClass
                          }
                          iconPosition="left"
                          icon={edit ? buttonProps.save.icon : buttonProps.edit.icon}
                          buttonRadius="6px"
                          buttonClass={
                            edit ? buttonProps.save.btnClass : buttonProps.edit.btnClass
                          }
                          loadingIcon={
                            loading ? (
                              <LoadingIndicator className="text-white w-4 h-4" />
                            ) : null
                          }
                          disabled={loading}
                          onClick={() => {
                            if (edit) {
                              onClickSave();
                            } else {
                              setEdit((prev) => !prev);
                            }
                          }}
                        />
                    </li>
                    <li>
                        <Button
                            disabled={loadingTranslate}
                            buttonName={
                                <div className="flex gap-2 items-center">
                                    <IoLanguageOutline/>
                                    <div>{t('translate')}</div>
                                </div> 
                            }
                            buttonTextClass="text-lg  flex flex-row items-center gap-2"
                            buttonRadius="6px"
                            icon={
                            loadingTranslate ? (
                                <LoadingIndicator className="text-primary w-4 h-4" />
                            ) : null
                            }
                            buttonClass="relative px-6 py-2 bg-white hover:bg-gray hover:rounded-b-md justify-start w-full"
                            onClick={translateGroupMemInfo}
                        />
                    </li>                     
                </ul>
            </div>
            </Popup> 
            }
            </> 
        )}
      </div>
      <div>
        {!edit && members.map((mem, index) => {
          return (
            <> 
              <div className="flex w-3/4 mt-1" key={index}>
                <div className="border-l-[3px] border-slate-200 font-semibold text-base flex-1 pl-4 capitalize"
                  dangerouslySetInnerHTML={{ __html: mem?.mention || (translate?.[lang]?.[mem?.name]  || mem?.name) }}
                >
                  {/* {mem.name} */}
                </div>
                <div className="text-base flex-1">{translate?.[lang]?.[mem?.role] || mem.role}</div>
                <div className="text-base flex-1">{translate?.[lang]?.[mem?.dateSE] || mem.dateSE}</div>
              </div> 
            </>
          );
        })}
        {
          edit && 
          <div className="w-full 3md:w-14/20">
          <Members
            items={members}
            setItems={setMembers}
            // errors={state.validationErrors}
            onAdd={onAddMembers}
            onChange={(e, index) => onChange(e, index)}
            onRemove={(index) => onRemoveMembers(index)}
            showAddBTN={false}
            customStyle={
              { 
                left: "auto !important",
                top: "auto !important",
              }
            }
          />
        </div>
        }
      </div>
    </div>
  );
};

export default GroupMembers;
